import React, { useEffect, useState } from "react"
import Img from "gatsby-image"
import HeartScore from "../../atoms/heart-score/heart-score"
import Button from "../../../shared/components/atoms/button/button"
import warnIco from "../../../assets/images/warn-ico.jpg"
import "./grid-products.scss"
import { pushDataLayerEvent, pushGtagEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { createListProductPayload } from "../../../shared/utils/payloadDatalayer"
import { datalayerProduct } from "../../../shared/utils/datalayerProducts"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const GridProducts = props => {
  const {
    products,
    listView,
    currentCategory,
    currentSubcategory,
    listAverage,
    ctaSubcategoria,
  } = props

  const item_list_name = `${currentCategory} > ${currentSubcategory} > Catalogo`.toLocaleLowerCase()
  const userInfoEncrypt= encryptUserInfo()

  const productGaEvent = ({ product }) => {
    const items = createListProductPayload([product], {
      item_list_name,
      item_category: currentSubcategory,
      item_list_id: "PF_2345",
    })

    pushGtagEvent({
      event: "select_item",
      params: {
        items,
        item_list_name,
        item_list_id: "PF_2345",
        redemption: "No",
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
    pushDataLayerEvent({
      event: "product_click",
      single_item_id: items[0].item_id,
      single_item_name: items[0].item_name,
      link_text: "Conócelas",
      link_url: window.location.host + removeDoubleSlash(`/productos/${currentCategory}/${currentSubcategory}/${product.slug}`)
    })
  }

  // dispatch datalayer on load page
  useEffect(() => {
    const items = createListProductPayload(products, {
      item_list_name,
      item_category: currentSubcategory,
      item_list_id: "PF_2345",
    })

    pushGtagEvent({
      event: "view_item_list",
      params: {
        items,
        item_list_name,
        item_list_id: "PF_2345",
        redemption: "No",
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
  }, [])

  const textDescriptionProductIntima = () => {
    switch (process.env.LOCALE) {
      case "es-CL":
        return "Calzón reutilizable que absorben el flujo menstrual sin necesidad de un producto adicional. Especiales para flujo menstrual leve a moderado."
      default:
        return "Panties reutilizables que absorben el flujo menstrual sin necesidad de un producto adicional. Especiales para flujo menstrual leve a moderado."
    }
  }

  return (
    <>
      {/* {products.length !== 0 &&
        products[0].codigoDeProducto.includes("SECRET") && (
          <p className="f-description-product-intima">
            {textDescriptionProductIntima()}
          </p>
        )} */}

      <div
        className={`f-grid-products-container ${
          listView ? "f-list-view " : "f-grid-view "
        }`}
      >
        {products.length !== 0 &&
          products.map((product, index) => (
            <a
              className="f-product"
              key={product.id}
              href={removeDoubleSlash(`/productos/${currentCategory}/${currentSubcategory}/${product.slug}`)}
              onClick={() => {
                datalayerProduct({subCategory: currentSubcategory, label: product.titulo})
                productGaEvent({ product })
              }}
            >
              <Img
                className="f-product__img"
                objectFit="contain"
                fluid={product.imagenDelProducto.fluid}
              />

              <h3 className="f-product__title">{product.titulo}</h3>
              <div className="f-product-info">
                <h3 className="f-product__title">{product.titulo}</h3>
                <p className="f-product__description">
                  {product.descripcionCorta?.descripcionCorta}
                </p>
                <HeartScore score={listAverage[product.codigoDeProducto]} />
                <Button
                  title={ctaSubcategoria}
                  className="new-dark-blue "
                  onClick={() => {
                    window.location.href(
                      removeDoubleSlash(`/productos/${currentCategory}/${currentSubcategory}/${product.slug}`)
                    )
                  }}
                />
              </div>
            </a>
          ))}
      </div>
      {products.length === 0 && (
        <div className="f-warn-filter">
          <img className="f-warn-ico" src={warnIco} alt="Imagen advertencia" />
          <p className="f-text-warn">
            No encontramos productos con las características que buscas. Intenta
            seleccionando otras opciones
          </p>
        </div>
      )}
    </>
  )
}

export default GridProducts
